import { getConsent } from "./getConsent";

/**
 * Determine whether you have all the desired consents.
 *
 * Returns `true` if have all consents, and `false` if any of the consents are
 * missing.
 *
 * @example
 * import { TARGETING_AND_ADVERTISING_COOKIES_ID, hasConsent } from "@asosteam/asos-web-consent";
 *
 * const targetingAndAdvertisingAllowed = hasConsent([TARGETING_AND_ADVERTISING_COOKIES_ID]);
 *
 * if (targetingAndAdvertisingAllowed) {
 *   // ... consent driven code
 * }
 *
 * @param {string[]} consentCategoryIds Array of desired consent category ids.
 * @returns {boolean}
 */
export const hasConsent = consentCategoryIds => {
  const consent = getConsent();

  return consentCategoryIds.every(
    consentCategoryId => consent[consentCategoryId]
  );
};
